import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a49f6b2a")

_pushScopeId("data-v-a49f6b2a")
const _hoisted_1 = {
  class: "product-list-item",
  "data-test": "productListItem"
}
const _hoisted_2 = { class: "product" }
const _hoisted_3 = { class: "product__name" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "product__edit" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-angle-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ['status', _ctx.statusStyle]
    }, _toDisplayString(_ctx.product.priority), 3),
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.product.name), 1),
      _hoisted_4
    ])
  ]))
})